<template>
  <div class="loginPageBox">
    <div class="logo">
      <img
        src="../assets/login/login_logo_blue.png"
        width="160px"
        height="30px"
        alt=""
      />
    </div>
    <div class="loginBox">
      <div class="loginBoxTitle">
        <p class="title">{{ $t("title.loginTitle") }}</p>
      </div>
      <div class="loginForm">
        <el-form
          v-if="loginType == 'normal'"
          :model="loginForm"
          :hide-required-asterisk="true"
          :rules="loginFormRules"
          ref="loginForm"
        >
          <el-form-item prop="username" class="input">
            <el-input v-model="loginForm.username">
              <i
                slot="prefix"
                class="el-input__icon el-icon-my-user customIcon"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password" class="input">
            <el-input
              v-model="loginForm.password"
              type="password"
              show-password
              @keyup.enter.native="login()"
            >
              <i slot="prefix" class="el-input__icon el-icon-my-lock"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="login()" style="width: 100%">{{
              $t("button.login")
            }}</el-button>
          </el-form-item>
        </el-form>
        <div class="wxQrcodeBox" v-if="loginType == 'wx'">
          <div id="wxQrcode" ref="wxQrcode"></div>
        </div>
        <div class="otherLoginBox">
          <el-button
            v-if="loginType == 'normal' && this.wxSwitch == true"
            type="text"
            @click="changeLogin()"
            >{{ $t("button.wxLogin") }}</el-button
          >
          <el-button
            v-if="loginType == 'wx'"
            type="text"
            @click="changeLogin()"
            >{{ $t("button.normalLogin") }}</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import aes from "@/utils/aes.js";
import { guid } from "@/utils/utils.js";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      loginFormRules: {
        username: [{ required: true, message: " ", trigger: blur }],
        password: [{ required: true, message: " ", trigger: blur }],
      },
      loginForm: {
        username: "",
        password: "",
      },

      // 登陆类型
      loginType: "normal",
      //登录成功定时器
      loginCallBackInterval: "",
      //二维码超时定时器
      qrcodeOverTimeInterval: "",

      //微信登录随机串
      wxLoginStr: "",
      //微信登录是否开启
      wxSwitch: false,
    };
  },

  created() {
    this.getWxSwitch();
  },
  methods: {
    login() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          let submitInfo = {
            username: this.loginForm.username,
            password: md5(
              this.loginForm.password + this.loginForm.username
            ).toUpperCase(),
          };
          return new Promise((resolve, reject) => {
            this.$httpList
              .login(submitInfo)
              .then((res) => {
                if (res.resultCode == 1001) {
                  localStorage.setItem("as-username", res.data.username);
                  //token 加密存储
                  localStorage.setItem(
                    "accessToken",
                    // aes.encrypt(res.data.access_token)
                    res.data.access_token
                  );
                  if (localStorage.getItem("accessToken")) {
                    // //TODO  把加密后的accessToken 解密
                    this.$actions.setGlobalState({
                      accessToken: res.data.access_token,
                    });
                    /**
                     * 0 未开启   无需处理 正常登陆进入
                     * 1 用户自开启   默认进入输入验证码页面
                     * 2 强制开启    进入验证码页面
                     * 3 强制开启未绑定  进入强制绑定页面
                     * 4 已绑定未开启     无需处理  正常登陆进入
                     */
                    //Google登录注册
                    if ([1, 2].includes(res.data.googleType)) {
                      this.$router.push({
                        name: "GoogleLogin",
                        params: {
                          username: submitInfo.username,
                        },
                      });
                    } else if (res.data.googleType == 3) {
                      this.$router.push({
                        name: "ForceBind",
                        params: {
                          username: submitInfo.username,
                        },
                      });
                    } else if ([0, 4].includes(res.data.googleType)) {
                      this.$router.push({
                        name: "Home",
                      });
                    }
                  } else {
                    this.$notify({
                      type: "error",
                      message: this.$t("promptMessage.getTokenError"),
                    });
                  }

                  console.log(this.$actions.getGlobalState());
                  resolve(res);
                }
              })
              .catch((err) => {
                reject(err);
              });
          });
        }
      });
    },
    changeLogin() {
      if (this.loginType == "normal") {
        this.wxLoginStr = guid();
        this.loginType = "wx";
        this.getQrCode();
        //调用微信获取二维码 内容 然后绘制二维码
      } else {
        this.loginType = "normal";
        window.clearInterval(this.loginCallBackInterval);
      }
    },
    getQrCode() {
      return new Promise((resolve, reject) => {
        let submitInfo = {
          key: "wxlogin",
          loginStr: this.wxLoginStr,
        };
        this.$httpList
          .getWxQrCodeContent(submitInfo)
          .then((res) => {
            if (res.resultCode == 1001) {
              console.log(res);
              this.$refs.wxQrcode.innerHTML = ""; // 清除二维码方法
              new QRCode("wxQrcode", {
                text: res.data.qrCodeContent,
                width: 200,
                height: 200,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H,
              });

              this.loginCallBackInterval = window.setInterval(() => {
                this.wxLogin().then((rs) => {
                  if (rs.resultCode == 1001) {
                    window.clearInterval(this.loginCallBackInterval);
                    this.$notify.success({
                      message: this.$t("wechat.loginSuccess"),
                    });

                    localStorage.setItem("as-username", rs.data.username);
                    //token 加密存储
                    localStorage.setItem(
                      "accessToken",
                      aes.encrypt(rs.data.access_token)
                    );
                    if (localStorage.getItem("accessToken")) {
                      this.$actions.setGlobalState({
                        accessToken: rs.data.access_token,
                      });
                      this.$router.push({
                        name: "Home",
                      });
                    } else {
                      console.log("获取token失败");
                    }
                  }
                });
              }, 1000);
            }

            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      }).then(() => {});
    },
    wxLogin() {
      return new Promise((resolve, reject) => {
        let submitInfo = {
          loginStr: this.wxLoginStr,
        };
        this.$httpList
          .wxLogin(submitInfo)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getWxSwitch() {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getSystemWxConfig()
          .then((res) => {
            if (res.resultCode == 1001) {
              if (res.data) {
                this.wxSwitch = res.data.value;
              } else {
                this.wxSwitch = false;
              }
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-icon-my-user {
  margin-left: 5px;
  background: url("../assets/login/user.png") center no-repeat;
}

.el-icon-my-lock {
  margin-left: 5px;
  background: url("../assets/login/lock.png") center no-repeat;
}

.loginPageBox {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: url("../assets/login/ic_bg.png");
  background-attachment: fixed;
  background-size: cover;
  align-items: center;
  justify-content: center;
  align-content: center;
  .logo {
    position: fixed;
    top: 50px;
    left: 80px;
  }
  .loginBox {
    min-height: 23%;
    width: 23%;
    min-width: 380px;
    border-radius: 10px;
    box-shadow: 4px 4px 16px 0px rgba(54, 62, 74, 0.7);
    .loginBoxTitle {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      height: 15%;
      background: url("../assets/login/loginrightbg.png");
      display: flex;
      align-content: center;
      justify-content: center;
      align-items: center;

      .title {
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
    }
    .loginForm {
      background: white;
      padding: 5% 15%;
      border-radius: 10px;

      .wxQrcodeBox {
        width: 100%;
        height: 320px;
        // min-height: 80%;
        display: flex;
        justify-content: center;
        // background: wheat;
        align-items: center;
      }

      .el-form-item {
        margin-top: 60px !important;
        margin-bottom: 60px !important;
      }
      ::v-deep .el-input--prefix .el-input__inner {
        padding-left: 42px !important;
      }
      ::v-deep .el-input {
        border-radius: 8px !important;
        .el-input__inner {
          border-radius: 8px !important;
        }
      }
      .otherLoginBox {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        margin-bottom: 5px;
      }
    }
  }
}
</style>
